import React, { useState, useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';

import axios from 'axios';
import Spinner from "./Spinner";
import './styles.scss';
import { toastr } from "react-redux-toastr";
import {loadStripe} from "@stripe/stripe-js";
import StripePaymentForm from "./StripePaymentForm";
import {ActionCable} from "react-actioncable-provider";
import { BarLoader } from 'react-spinners';

const stripePromise = loadStripe(window.stripeKey, {
  betas: ["blocked_card_brands_beta_2"],
});


export default ({ spinnerMessage, buttonTitle, paymentPath, setShow, successMessage }) => {
  const [processing, setProcessing] = useState(false);
  const [paymentOptions, setPaymentOptions] = useState(null);

  useEffect(() => {
    const fetchPaymentData = async () => {
      try {
        const response = await axios.get(paymentPath);

        if (response.data.interruption) {
          console.warn(response.data.interruption.status);
          toastr.error('', "Something went wrong!");
        } else {
          return response.data.paymentOptions
        }
      } catch (err) {
        toastr.error('Something went wrong!');
        console.error('Error fetching payment data', err);
      }
    };

    fetchPaymentData().then((newPaymentOptions) => {
      setPaymentOptions(newPaymentOptions)
    });

    return () => {
      setPaymentOptions(null);
    }
  }, [])

  const handleReceived = (message) => {
    switch (message.status) {
      case 'successful':
        if (paymentOptions.redirectTo) {
          window.location.href = paymentOptions.redirectTo;
        } else {
          if (successMessage) toastr.success('', successMessage);
          setProcessing(false);
          setShow(false);
        }
        break;
      case 'failed':
        setProcessing(false)
        toastr.error('', message.error_messages.join(', '));
        break;
    }
  }

  return (
    <>
      {paymentOptions && paymentOptions.modificationId &&
        <ActionCable
          channel={{ channel: 'ModificationChannel', id: paymentOptions.modificationId }}
          onReceived={handleReceived}
          onConnected={() => { console.log('onConnected')  }}
        />
      }

      <Spinner
        show={processing}
        message={spinnerMessage}
      />

      {!paymentOptions &&
        <div style={{ display: 'flex', placeContent: 'center', padding: '30px 20px' }}>
          <BarLoader color="#085dad" width={200} height={10} />
        </div>
      }

      {paymentOptions &&
        <Elements stripe={stripePromise}
                  options={{
                    clientSecret: paymentOptions.clientSecret,
                    appearance: { theme: 'stripe' },
                    allowedCardBrands : ["visa", "mastercard"]}}>
          <StripePaymentForm
            buttonTitle={buttonTitle}
            paymentOptions={paymentOptions}
            setProcessing={setProcessing}
            paymentPath={paymentPath}
          />
          <br/>
        </Elements>
      }
    </>
  );
};

// import Cookies from 'js-cookie'
//     if (error !== undefined) {
//       if (error.redirectTo) {
//         Cookies.set('FullyBookedMessage', error.message)
//         window.location.href = error.redirectTo;
//       }
//       return;
//     }


// useEffect(() => {
//   if (!processing) setPaymentOptions(null);
// }, [processing])
